const PHONE_NUMBER_MASK = '## ### ### ####';

export { PHONE_NUMBER_MASK };
